const buildYears = (count = 4) => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: count }, (_, idx) => currentYear + idx);
};

const buildDays = days => {
  return Array.from({ length: days }, (_, idx) => idx + 1);
};

const MONTHS = Array.from({ length: 12 }, (_, idx) => idx + 1);

const ensureYearInRange = (years, targetYear) => {
  if (!targetYear || years.includes(targetYear)) {
    return years;
  }
  const merged = [...years, targetYear];
  return merged.filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a - b);
};

module.exports = {
  buildYears,
  buildDays,
  MONTHS,
  ensureYearInRange,
};
